import { get, set } from 'lodash';

interface Microcopy {
    id: string;
    key: string;
    value: { value: string };
    node_locale: string;
}

interface MicrocopyNode {
    resources: Microcopy[];
}

export default class MicrocopyHelper {
    private items = {};

    constructor(private locale: string) { }

    public add(contentfulResourceSet: MicrocopyNode[]) {
        this.prepare(contentfulResourceSet);

        return this;
    }

    public get(key: string, defaultValue: string = '') {
        return get(this.items, [ this.locale, key ])?.value ?? defaultValue;
    }

    public getId(key: string) {
        return get(this.items, [ this.locale, key ])?.id;
    }

    public getWithId(key: string, defaultValue: string = '') {
        const item = get(this.items, [ this.locale, key ]);
        return {
            id: item?.id,
            value: item?.value ?? defaultValue,
        };
    }

    private prepare(nodes: MicrocopyNode[]) {
        nodes.forEach(node => {
            node.resources.forEach(item => {
                set(
                    this.items,
                    [
                        item.node_locale,
                        item.key,
                    ],
                    {
                        id: item.id,
                        value: item.value?.value,
                    },
                );
            });
        }, this.items);
    }
}
